import { template_en } from "./template";
import { credentials_en } from "./credentials";
import { sequence_detail_steps_en } from "./detail_steps";
import { sequence_detail_settings_en } from "./detail_settings";
import { sequence_detail_logs_en } from "./detail_logs";
import { sequence_detail_targets_en } from "./detail_targets";
import { sequence_detail_report_en } from "./detail_report";
import { sequence_wizard_en } from "./wizard";
export default {
  sequence_main_timeout_title:
    "Set to activate on {datetime}. You can reschedule anytime below.",

  /** tabs */
  sequence_tab_overview: "Overview",
  sequence_tab_templates: "Templates",
  sequence_tab_analytics: "Analytics",
  sequence_tab_meetings: "Meetings",
  sequence_tab_credentials: "Credentials",
  sequence_tab_settings: "Settings",

  /** aside */
  sequence_overview_aside_create_new_label: "Create new label",
  sequence_overview_labels_total:
    "0 Sequences | 1 Sequence | {count} Sequences",

  /** label form */
  sequence_overview_label_create_dialog_name: "New Label",
  sequence_overview_label_edit_dialog_name: "Rename Label",
  sequence_overview_label_create_dialog_input_label:
    "Please enter a new label name",
  sequence_overview_label_edit_dialog_input_label: "Please enter a label name",
  sequence_overview_label_create_dialog_input_oplaceholder:
    "Enter a new label name",
  sequence_overview_label_edit_dialog_input_placeholder: "Enter a label name",
  create_sequence_label_success: "A label created",
  create_sequence_label_failed: "Failed to create",
  update_sequence_label_success: "Updated successfully",
  update_sequence_label_failed: "Failed to update",

  /** filters */
  sequence_overview_filters_creator: "Creator",
  sequence_overview_filters_label: "Labels",
  sequence_overview_filters_starred: "Starred",
  sequence_overview_filters_state: "State",

  sequence_filter_status_active: "active",
  sequence_filter_status_inactive: "inactive",
  /** table */
  sequence_overview_table_label_panel_empty:
    "You don't have any labels yet. Click the '⊕' button to create your first label and start organizing!",
  sequence_overview_label_panel_search_placeholder: "Search labels",
  add_label_to_sequence_successfully: "Added successfully",
  add_label_to_sequence_failed: "Failed to add",
  remove_label_from_sequence_successfully: "Removed successfully",
  remove_label_from_sequence_failed: "Failed to remove",

  sequence_overview_table_name_sequence_name: "Sequence name",
  sequence_overview_table_name_people: "People",
  sequence_overview_table_name_click_rate: "Click rate",
  sequence_overview_table_name_open_rate: "Open rate",
  sequence_overview_table_name_reply_rate: "Reply rate",
  sequence_overview_unsave_count:
    "no of selected sequences | one of selected sequences | {count} of selected sequences",

  /** create sequence */
  sequence_overview_create_sequence_dialog_name: "New Sequence",
  sequence_overview_create_sequence_dialog_input_label:
    "Please enter a sequence name",
  sequence_overview_create_sequence_dialog_input_placeholder: "Sequence name",

  /** detail empty */
  sequence_detail_error_title: "Oops! We couldn’t fetch the data.",
  sequence_detail_error_desc:
    "the link might be incorrect or the data is unavailable. Please check the URL or changed the selected one and try again.",
  sequence_detail_error_back: "Return to Sequence List",

  /** detail header */
  sequence_detail_delete: "Delete this sequence",
  sequence_detail_delete_dialog_title: "Delete Sequence",
  sequence_detail_delete_dialog_subtitle:
    "This will delete the entire sequence, including all settings and data.",
  sequence_detail_delete_dialog_desc:
    "Once deleted, this sequence cannot be recovered. Are you sure you want to continue?",

  /** detail nav */
  sequence_detail_nav_inbox: "Inbox",
  sequence_detail_nav_steps: "Steps",
  sequence_detail_nav_report: "Report",
  sequence_detail_nav_analytics: "Analytics",
  sequence_detail_nav_prospects: "Targets",
  sequence_detail_nav_settings: "Settings",
  sequence_detail_nav_logs: "Logs",
  sequence_detail_nav_interactions: "Interactions",

  /** detail step canvas */
  sequence_detail_workflow_time_delay: "Delay",
  sequence_detail_workflow_time_monitor: "Monitor",
  sequence_detail_workflow_time_run_immediately: "Set to run immediately",
  sequence_detail_steps_add_first_step: "Add first step...",

  /** detail step canvas create node */
  sequence_detail_workflow_create_node_level1_title: "What happens next?",
  sequence_detail_workflow_create_node_level2_title: "Choose channel",
  sequence_detail_workflow_create_node_level3_title:
    "Choose condition/action type",

  /** detail step setting panel credential */
  sequence_detail_setting_credential_label: "Credential:",
  sequence_detail_setting_credential_primary_flag: "Primary",
  sequence_detail_setting_credential_primary_opeator: "Set as primary",
  sequence_workflow_unsave_changes_title: "Unsaved Changes",
  sequence_workflow_unsave_changes_desc:
    "There are unsaved changes. You can save the changes or leave this page and discard them.",
  leave: "Leave",
  discard: "Discard",
  sequence_workflow_version_unsaved_changes_description:
    "There are unsaved changes in the current version. You can go back to edit or save the changes.",
  sequence_workflow_version_invalid_dialog_title:
    "Unvalidated fields in the current flowchart",
  sequence_workflow_version_invalid_dialog_primary_button:
    "back to current version",
  sequence_workflow_version_invalid_dialog_description:
    "There are unvalidated fields in the current version. You can go back to update these fields or discard the changes.",
  back: "back",

  editor_toolbar_image_upload: "Upload",
  editor_toolbar_image_url: "URL",
  choose_file: "Choose file",
  to_upload: "to upload",
  editor_toolbar_image_popover_url_label: "Image URL",
  insert: "Insert",

  set_schedule: "Set schedule",

  sequence_main_schedule_title: "Schedule sequence",
  start_now: "Start now",
  schedule_start: "Schedule start",
  activate_sequence: "Activate sequence",

  sequence_no_credentials_banner_title:
    "Connect your email or messaging account to send sequences from Pubrio",
  sequence_no_credentials_banner_title_suffix: " · under 5 min",
  sequence_no_credentials_banner_desc:
    "This setup is required before you can start or send any sequence.",
  sequence_no_credentials_banner_button: "Connect sending account",

  sequence_detail_out_of_schedule_popup_message:
    "<strong>Sequence is active but outside schedule</strong>  —  No messages are being sent right now. Business hours are {0}. Sending resumes <strong>{1}.</strong>",
  sequence_list_out_of_schedule_popup_message:
    "<strong>Heads up!</strong> It's currently outside your sending schedule({0}). Your sequence will be activated, but the first message won't go out until <strong>{1}.</strong>",
  dismiss: "Dismiss",
  edit_schedule: "Edit schedule",
  broken_steps_popup_message:
    "Some steps are incomplete in default version — fix them to activate.",

  broken_step_save_warning_title: "Save as draft?",
  broken_step_save_warning_desc_1: "Some steps aren't complete yet. ",
  broken_step_save_warning_desc_2:
    "You can save a draft and come back to it, but this sequence can't be activated until everything is finished.",
  broken_step_save_warning_primary_button_text: "Save as draft",
  broken_step_save_warning_default_button_text: "Continue editing",
  broken_step_disable_activation_warning_title: "Save incomplete steps?",
  broken_step_disable_activation_warning_primary_button_text: "Save and pause",
  broken_step_disable_activation_warning_default_button_text:
    "Continue editing",
  broken_step_disable_activation_warning_desc_1:
    "This sequence is currently active. ",
  broken_step_disable_activation_warning_desc_2:
    "Saving now will pause it until all steps are complete and it's re-activated.",
  ...template_en,
  ...credentials_en,

  ...sequence_detail_steps_en,
  ...sequence_detail_settings_en,
  ...sequence_detail_logs_en,
  ...sequence_detail_targets_en,
  ...sequence_detail_report_en,
  ...sequence_wizard_en,
};
